import React from "react";
import { Button, useNotify, useRefresh } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { candidateRequests } from "api/candidateApi";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const FinalizeCampaignButton = ({ id, disabled, campaignName }) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const handleFinalizeCampaign = async () => {
    await dataProvider.customRequest(candidateRequests.finalizeCampaign(id), null, "POST");
    refresh();
    notify("Успешно финализиране на кампанията", { type: "success" });
  };

  return (
    <ConfirmModal
      onConfirm={handleFinalizeCampaign}
      titleContent={"Завърши кампания"}
      message={`Сигурни ли сте, че искате да завършите ${campaignName}?`}
      triggerButton={
        <Button
          label="Завърши кампания"
          startIcon={<CheckCircleOutlineIcon />}
          variant="contained"
          size="medium"
          color="error"
          disabled={disabled}
        />
      }
    />
  );
};

export default FinalizeCampaignButton;
